import React, { useContext } from "react";
import { useLayoutEffect } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { DataContext } from "contexts/DataContext";

interface DonutProps {
  name: string;
  increment?: string;
  data: Array<{ sector: string; size: number }>;
}

const PostureDonut: React.FC<DonutProps> = (props) => {
  const dataContext = useContext(DataContext);
  const isDark = !!dataContext.darkMode;

  useLayoutEffect(() => {
    // Create root
    const root = am5.Root.new(props.name);
    root._licenseApplied();
    root.setThemes([am5themes_Animated.new(root)]);

    // Create chart
    const chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        innerRadius: 28,
        layout: root.verticalLayout
      })
    );

    // Create series
    const series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "size",
        categoryField: "sector",
        startAngle: -90,
        endAngle: 270,
        alignLabels: false
      })
    );

    // Hide default slice labels and ticks
    series.labels.template.setAll({ visible: false, disabled: true });
    series.ticks.template.setAll({ visible: false, disabled: true });

    // Set colors: background (gray) then value (blue indicator in all modes)
    series.get("colors")?.set("colors", [
      am5.color(0x58585a), // gray background
      am5.color(0x4f8fdf)  // blue indicator
    ]);

    // Slice styling
    series.slices.template.setAll({
      tooltipText: "{value}%",
      width: am5.percent(100),
      cornerRadius: 0
    });

    // Set data and animate
    series.data.setAll(props.data);
    series.appear(1000, 100);

    // Add center label
    chart.seriesContainer.children.push(
      am5.Label.new(root, {
        text: `${props.increment}%`,
        centerX: am5.percent(50),
        centerY: am5.percent(50),
        textAlign: "center",
        fontSize: 16,
        fontFamily: "Jost, Helvetica, Arial, sans-serif",
        fontWeight: "700",
        fill: am5.color(isDark ? 0xffffff : 0x000000)
      })
    );

    return () => {
      root.dispose();
    };
  }, [props.name, props.data, props.increment, isDark]);

  return <div id={props.name} style={{ width: 80, height: 80 }} />;
};

export default PostureDonut;
